import {
	USER_ROLE_ADMIN,
	USER_ROLE_AFFILIATE,
	USER_ROLE_AGENT,
	USER_ROLE_EDITING_MANAGER,
	USER_ROLE_EDITOR,
	USER_ROLE_PHOTOGRAPHER,
	USER_ROLE_REGIONAL_MANAGER,
	USER_ROLE_SALES
} from '../Config/Constants';

export const getPermissionForListing = (signedInUser, listing) => {
	if (!signedInUser || !listing) return;

	switch (signedInUser.role) {
		case USER_ROLE_ADMIN:
		case USER_ROLE_REGIONAL_MANAGER:
		case USER_ROLE_SALES:
		case USER_ROLE_AFFILIATE:
			return true;
		case USER_ROLE_AGENT:
			return listing.client && listing.client.id === signedInUser.id;
		case USER_ROLE_PHOTOGRAPHER:
			return listing.client && listing.client.id === signedInUser.id;
		case USER_ROLE_EDITING_MANAGER:
		case USER_ROLE_EDITOR:
			return false;
		default:
			break;
	}
};
